import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { Switch, Route } from 'react-router'
import useGetPadInfo from '@/hooks/use-get-pad-info'
import useBetaUser from '@/hooks/use-beta-user'
import useCurrentSession from '@/hooks/use-current-session'
import { useFlag } from '@/flags'
import ManagePad from './manage-pad'
import BillingAddress from './billing-address'
import PaymentSettingsDashboard from './payment-settings-dashboard'

const TenantPaymentSettings = () => {
  const { t } = useTranslation()
  const session = useCurrentSession()
  const betaUser = useBetaUser()
  const betaUserPad = betaUser?.pad ?? []
  const currentBetaUser = betaUserPad.includes(parseInt(session.id))
  const showPad = useFlag(['features', 'pad'], false) && currentBetaUser

  const { data } = useGetPadInfo({ enabled: showPad })
  return (
    <>
      <Helmet>
        <title>{t('l.settings.view.payment_settings.title', 'Payment Settings')}</title>
      </Helmet>
      <Switch>
        {showPad && (
          <Route
            exact
            path="/settings/payment-settings/pre-authorized-debit"
            render={props => <ManagePad {...props} padInfo={data} />}
          />
        )}
        <Route exact path="/settings/payment-settings/billing-address" component={BillingAddress} />
        <Route
          exact
          path="/settings/payment-settings"
          render={() => <PaymentSettingsDashboard padInfo={data} />}
        />
      </Switch>
    </>
  )
}

export default TenantPaymentSettings
